import { createContext } from 'react';

export type ABTestContextPossibleTriggers = 'load' | 'click' | 'delay' | 'redirect' | 'submit' | 'scroll' | 'visible';

export interface ABTestContextProps {
  /** The branch the AB Test should be using. */
  branch: string | null;
  /** The trigger that enables the AB Test. */
  trigger: ABTestContextPossibleTriggers;
  /** Checks if the trigger has fired for the AB Test. */
  hasTriggerFired: boolean;
  /** The selector used in the AB Test. */
  selector?: string;
  /** A function that triggers the AB Test. */
  triggerCurrentTest: () => void;
  /** Determins if the AB Test shield should be displayed. */
  shouldShowShield?: boolean;
}

const defaultContext: ABTestContextProps = {
  branch: null,
  trigger: 'load',
  hasTriggerFired: false,
  selector: undefined,
  triggerCurrentTest: () => undefined,
  shouldShowShield: false,
};

export default createContext(defaultContext);
